import { useSelector, useDispatch } from 'react-redux';
import { useWindowWidth } from '@react-hook/window-size';
import { useEffect } from 'react';

const useIsDesktop = () => {
  const dispatch = useDispatch();
  const windowWidth = useWindowWidth();

  useEffect(() => {
    dispatch(
      {
        type: 'accounts/updateIsDesktop',
        payload: windowWidth > 768,
      },
    );
  }, [dispatch, windowWidth]);

  return useSelector((state) => state.accounts.isDesktop);
};

export default useIsDesktop;
